// extracted by mini-css-extract-plugin
export default {"search":"oryx-input-search_search__ypFw9","search__clear-button":"oryx-input-search_search__clear-button__Ht7BG"};